/**
 * Hook for packing-related actions (pack, unpack, close, etc.)
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { packItem, packKitItem, unpackItem, closePackage, closeBulkPackage, deletePackage, deleteAllPackages, resetPackage, resetAllPackages, updatePackage, markShipmentPacked, markShipmentShipped, updateAddress, getReturnLabel, getMainLabel, getCartonLabel, cancelShipment, updatePackageContentQuantity, scanProductForPacking, selectShipmentId, packItemBySourceId, fetchRefundLabel } from '../../../redux/packing';
export var usePackingActions = function () {
    var dispatch = useDispatch();
    var shipmentId = useSelector(selectShipmentId);
    // Pack item
    var handlePackItem = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(packItem(__assign(__assign({ shipmentId: shipmentId }, params), { shipmentPackageSeqId: params.shipmentPackageSeqId }))).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Pack item by source id
    var handlePackItemBySourceId = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(packItemBySourceId(__assign({ shipmentId: shipmentId }, params))).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Scan product to pack
    var handleScanProduct = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(scanProductForPacking({
                            scanId: params.scanId,
                            shipmentId: shipmentId,
                            shipmentItemDetailList: params.shipmentItemDetailList,
                            kitComponentProducts: params.kitComponentProducts,
                            shipmentPackageSeqId: params.shipmentPackageSeqId,
                            shipmentBoxTypeId: params.shipmentBoxTypeId,
                            quantity: params.quantity,
                            carton: params.carton,
                            serialNumber: params.serialNumber
                        })).unwrap()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Pack kit item
    var handlePackKitItem = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(packKitItem(__assign(__assign({ shipmentId: shipmentId }, params), { shipmentPackageSeqId: params.shipmentPackageSeqId }))).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Unpack item
    var handleUnpackItem = useCallback(function (assetIssuanceId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(unpackItem({ shipmentId: shipmentId, assetIssuanceId: assetIssuanceId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Close package
    var handleClosePackage = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(closePackage(__assign({ shipmentId: shipmentId }, params))).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Close bulk package
    var handleCloseBulkPackage = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(closeBulkPackage(__assign({ shipmentId: shipmentId }, params))).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Delete package
    var handleDeletePackage = useCallback(function (shipmentPackageSeqId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(deletePackage({ shipmentId: shipmentId, shipmentPackageSeqId: shipmentPackageSeqId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Delete all packages
    var handleDeleteAllPackages = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(deleteAllPackages({ shipmentId: shipmentId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Reset package
    var handleResetPackage = useCallback(function (shipmentPackageSeqId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(resetPackage({ shipmentId: shipmentId, shipmentPackageSeqId: shipmentPackageSeqId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Reset all packages
    var handleResetAllPackages = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(resetAllPackages({ shipmentId: shipmentId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Update package
    var handleUpdatePackage = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(updatePackage(__assign({ shipmentId: shipmentId }, params))).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Mark packed
    var handleMarkPacked = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(markShipmentPacked(__assign({ shipmentId: shipmentId }, params))).unwrap()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Mark shipped
    var handleMarkShipped = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(markShipmentShipped({ shipmentId: shipmentId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Cancel shipment
    var handleCancelShipment = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(cancelShipment({ shipmentId: shipmentId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Update address
    var handleUpdateAddress = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(updateAddress(__assign({}, params))).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Get return label
    var handleGetReturnLabel = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(getReturnLabel(__assign({ shipmentId: shipmentId }, params))).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Get main label
    var handleGetMainLabel = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(getMainLabel(__assign({ shipmentId: shipmentId }, params))).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Get carton label
    var handleGetCartonLabel = useCallback(function (productStoreId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(getCartonLabel({ shipmentId: shipmentId, productStoreId: productStoreId })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Refund label
    var handleRefundLabel = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(fetchRefundLabel({
                            shipmentId: shipmentId,
                            shipmentPackageSeqId: params.shipmentPackageSeqId,
                            carrierPartyId: params.carrierPartyId,
                            shippingGatewayConfigId: params.shippingGatewayConfigId
                        })).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    // Update quantity
    var handleUpdateQuantity = useCallback(function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, dispatch(updatePackageContentQuantity(__assign({ shipmentId: shipmentId }, params))).unwrap()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, shipmentId]);
    return {
        handlePackItem: handlePackItem,
        handlePackItemBySourceId: handlePackItemBySourceId,
        handleScanProduct: handleScanProduct,
        handlePackKitItem: handlePackKitItem,
        handleUnpackItem: handleUnpackItem,
        handleClosePackage: handleClosePackage,
        handleCloseBulkPackage: handleCloseBulkPackage,
        handleDeletePackage: handleDeletePackage,
        handleDeleteAllPackages: handleDeleteAllPackages,
        handleResetPackage: handleResetPackage,
        handleResetAllPackages: handleResetAllPackages,
        handleUpdatePackage: handleUpdatePackage,
        handleMarkPacked: handleMarkPacked,
        handleMarkShipped: handleMarkShipped,
        handleCancelShipment: handleCancelShipment,
        handleUpdateAddress: handleUpdateAddress,
        handleGetReturnLabel: handleGetReturnLabel,
        handleGetMainLabel: handleGetMainLabel,
        handleGetCartonLabel: handleGetCartonLabel,
        handleRefundLabel: handleRefundLabel,
        handleUpdateQuantity: handleUpdateQuantity
    };
};
export default usePackingActions;
